export enum ImageTypeDimentions {
    SQUARE_WIDTH = 116,
    SQUARE_HEIGHT = 165,
    BACKGROUND_WIDTH = 1200,
    BACKGROUND_HEIGHT = 237
}